var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadLinkIcon11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3670_40874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58203 8.88442C6.88506 9.29654 7.28506 9.63593 7.73354 9.87836C8.18203 10.1208 8.679 10.2662 9.20021 10.3026C9.7093 10.339 10.2305 10.2662 10.7032 10.0844C11.1881 9.9026 11.6245 9.62381 11.9881 9.26017L14.1335 7.11472C14.7881 6.43593 15.1517 5.53896 15.1396 4.59351C15.1396 3.66017 14.7517 2.75108 14.0851 2.09654C13.4184 1.42987 12.5214 1.05411 11.5881 1.04199C10.6548 1.04199 9.74567 1.39351 9.06688 2.04805L7.83051 3.2723M9.44264 7.44199C9.13961 7.02987 8.73961 6.69048 8.29112 6.44805C7.84264 6.20563 7.34567 6.06017 6.82445 6.02381C6.31536 5.98745 5.79415 6.06017 5.32142 6.24199C4.83657 6.42381 4.40021 6.7026 4.03657 7.06623L1.89112 9.21169C1.23657 9.89048 0.872938 10.7874 0.885059 11.7329C0.885059 12.6662 1.27294 13.5753 1.9396 14.2299C2.60627 14.8965 3.50324 15.2723 4.43657 15.2844C5.36991 15.2844 6.279 14.9329 6.95779 14.2784L8.18203 13.0541",
    stroke: "#494949",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.44824 5.74472V1.05469",
    stroke: "#494949",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.44856 6.05486L1.32129 4.60059",
    stroke: "#494949",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.46094 6.03593L3.57609 4.56348",
    stroke: "#494949",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3670_40874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadLinkIcon11);
export default __webpack_public_path__ + "static/media/Download_Link_Icon_1 1.037f2699983dc70e48ffeae2c28935c9.svg";
export { ForwardRef as ReactComponent };